import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {envAwarePost} from '../../../util/util'

export const sortSubscriptions = createAsyncThunk(
    'sortSubscriptions',
    async ({srcIdx,tgtIdx},{getState})=>{
        const state = getState()
        const ids = state.availableSubscriptions.ids
        return envAwarePost(
            'api/subscriptions/',
            {action:'sortSubscriptions',ids}
        )
    }
)

export const updateSubscription = createAsyncThunk(
	'subscriptions/update',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{
			action:'updateSubscription',
			...payload
		}
	)
)

//This gets the list of AVAILABLE subscriptions
//Ie things to which clients CAN subscribe
export const getAvailableSubscriptions = createAsyncThunk(
	'subscriptions/getAvailable',
	async () => await envAwarePost(
		'api/subscriptions/',
		{action:'getSubscriptions'}
	)
)

export const purchaseSubscription = createAsyncThunk(
	'subscriptions/purchase',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'purchaseSubscription',...payload}
	)
)

export const createSubscription = createAsyncThunk(
	'subscriptions/create',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'createSubscription',...payload}
	)
)

export const deleteSubscription = createAsyncThunk(
	'subscriptions/delete',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'deleteSubscription',...payload}
	)
)

export const deactivateSubscriptionPrice = createAsyncThunk(
	'subscriptions/price/deactivate',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'deactivateSubscriptionPrice',...payload}
	)
)

//adapter for subscriptions that can be edited/purchased
const adapter = createEntityAdapter()

//adapter for storing objects representing recurring charges
//on a specific client's account
const purchasedAdapter = createEntityAdapter({
	selectId:ent=>ent.stripe_subscription_id
})

const slice = createSlice({
	name: 'availalbeSubscriptions',
	initialState:adapter.getInitialState({
		status:'init',
		editor:{
			id:null
		},
		activeComponent:'subscriptions'
	}),
	reducers: {
		setEditor: (state,action) => { 
			state.editor = action.payload 
		},
		setActiveComponent: (state,action)=>{
			state.activeComponent = action.payload
		}
	},
	extraReducers: {
		//get all
		[getAvailableSubscriptions.pending] : (state,action) => {
			state.status = 'pending'
		},
		[getAvailableSubscriptions.fulfilled] : (state,action) => {
			state.status = 'idle'
			const {success,data,message} = action.payload
			if(success === '1'){
				adapter.upsertMany(state,data.subscriptions)
			}else{
				window.alert(message)
			}
		},
		//create
		[createSubscription.fulfilled] : (state,action) => {
			const {success,data} = action.payload
			if(success==='1') adapter.addOne(state,data.subscription)
		},
		//update
		[updateSubscription.fulfilled] : (state,action) => {
			const {success,data} = action.payload
			if(success==='1') adapter.upsertOne(state,data.subscription)
		},
		//delete
		[deleteSubscription.pending] : (state,action) => {
			const {id} = action.meta.arg
			adapter.removeOne(state,id)
		},
		[sortSubscriptions.pending]: (state,action)=>{
            const {srcIdx,tgtIdx} = action.meta.arg
            const ids = state.ids
            //get a temp array with the src item removed
            const tmpNoSrc = [
                ...ids.slice(0, srcIdx),
                ...ids.slice(srcIdx + 1)
            ]
            
            const idsUpdate = [
                ...tmpNoSrc.slice(0, tgtIdx),
                ids[srcIdx],
                ...tmpNoSrc.slice(tgtIdx)
            ]
            state.ids = idsUpdate
            idsUpdate.forEach((id,idx)=>{
                state.entities[id].sort_order = idx
            })
        }
	}
})

export const {
	setActiveComponent,
	setEditor
} = slice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllAvailableSubscriptions,
	selectById: selectAvailableSubscriptionById,
	selectIds: selectAvailableSubscriptionIds
} = adapter.getSelectors( state => state.availableSubscriptions )


export default slice.reducer